<template>
  <div>
    <v-row>
      <v-col class="text-right">
        <ModalInsert @load="load"></ModalInsert>
      </v-col>
    </v-row>

    <v-row>
      <v-col>
        <v-data-table
          :headers="headers"
          :items="payload"
          class="elevation-1"
          hide-default-footer
          disable-pagination
        >
          <template v-slot:item.acoes="{ item }">
            <v-row v-if="!item.nacional">
              <v-col cols="1">
                <ModalInsert
                  :edit="true"
                  :object="item"
                  @load="load"
                ></ModalInsert>
              </v-col>
            </v-row>
          </template>

          <template v-slot:item.acoes_delete="{ item }">
            <v-row v-if="!item.nacional">
              <v-col cols="1">
                <modal-delete :payload="item" @onLoad="load">
                  <template v-slot:title> Deletar Solução </template>
                </modal-delete>
              </v-col>

              <v-col cols="1"> </v-col>
            </v-row>
          </template>

          <template slot="no-data">
            <span> Nenhuma Solução retornada </span>
          </template>
        </v-data-table>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import ModalInsert from "@/modules/city/components/propostas/solucoesExtras/ModalInsert";
import { municipioPropostaSolucaoExtraApi } from "@/apis/proposta";
import ModalDelete from "@/modules/city/components/propostas/solucoesExtras/ModalDelete";

export default {
  components: {
    ModalInsert,
    ModalDelete,
  },

  data() {
    return {
      headers: [
        { text: "Solução", value: "nome" },
        { text: "Editar", value: "acoes", sortable: false },
        { text: "Excluir", value: "acoes_delete", sortable: false },
      ],
      payload: [],
      municipioId: this.$route.params.id,
    };
  },
  methods: {
    ...mapActions(["setLoading"]),
    load() {
      this.setLoading(true);
      municipioPropostaSolucaoExtraApi
        .listByMunicipio(this.municipioId)
        .then((resp) => {
          this.payload = resp.data;
          this.setLoading(false);
        })
        .catch((resp) => {
          this.setLoading(false);
          this.$notification.error("Erro ao obter soluções");
        });
    },
  },
  mounted() {
    this.load();
  },

  computed: {
    ...mapGetters(["user"]),
  },
};
</script>
